import { render, staticRenderFns } from "./BillingReminderModal.vue?vue&type=template&id=173bc6ca&scoped=true&"
import script from "./BillingReminderModal.vue?vue&type=script&lang=js&"
export * from "./BillingReminderModal.vue?vue&type=script&lang=js&"
import style0 from "./BillingReminderModal.vue?vue&type=style&index=0&id=173bc6ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173bc6ca",
  null
  
)

export default component.exports